import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { FormGroup } from "@angular/forms";

import { FormToolsService } from "@atenea-cms";
import { DownloadTypeService, DownloadTypeFormService } from "../shared";

@Component({
  selector: "download-type-form",
  templateUrl: "./download-type-form.component.html",
  styleUrls: ["./download-type-form.component.scss"],
})
export class DownloadTypeFormComponent implements OnInit {
  @Input() id: string;
  @Output() onSave: EventEmitter<string> = new EventEmitter();
  @Output() onDuplicate: EventEmitter<string> = new EventEmitter();
  @Output() onRemove: EventEmitter<string> = new EventEmitter();
  @Output() onBack: EventEmitter<any> = new EventEmitter();

  loading: boolean = false;
  form: FormGroup;

  constructor(
    public ft: FormToolsService,
    public dataService: DownloadTypeService,
    public formService: DownloadTypeFormService
  ) {}

  ngOnInit() {}

  ngOnChanges() {
    this.form = null;

    if (this.id) {
      this.loading = true;

      this.dataService.getById(this.id).subscribe((item) => {
        this.form = this.formService.getForm(item);
        this.loading = false;
      });
    } else {
      setTimeout(() => {
        this.form = this.formService.getForm();
      }, 100);
    }
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/download-types/download-type-form/download-type-form.component.ts